// DEV
// export const API_URL = "http://127.0.0.1:8000";
// export const IS_PROD = false;
// export const MOBILE_DOMAIN = "m.cubits.ai";

// PROD
export const API_URL = "https://api.staging.cubits.ai";
export const IS_PROD = true;
export const MOBILE_DOMAIN = "m.staging.cubits.ai";
